enum FileTypes {
  Document = 'document',
  CoverLetter = 'coverLetter'
};

export default FileTypes;
